// extracted by mini-css-extract-plugin
export var childrenContainer = "_bi-0";
export var virtualScrollArea = "_bi-1";